import { render, staticRenderFns } from "./placeholder-card-product.vue?vue&type=template&id=1320528e&scoped=true"
import script from "./placeholder-card-product.vue?vue&type=script&lang=js"
export * from "./placeholder-card-product.vue?vue&type=script&lang=js"
import style0 from "./placeholder-card-product.vue?vue&type=style&index=0&id=1320528e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1320528e",
  null
  
)

export default component.exports